import CodeBlockView from "./CodeBlock.svelte";
import { CodeBlockLowlight as CB } from "@tiptap/extension-code-block-lowlight";
import { mergeAttributes } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { SvelteSSRRenderer } from "$components/editor/utils";

// add ychange attribute to CodeBlock
export const CodeBlock = CB.extend({
  draggable: true,
  // this makes sure it accepts diffs inside it, otherwise the schema drops it
  marks: "ychange",
  addAttributes() {
    return {
      ...this.parent?.(),
      ychange: {
        default: null,
      },
      height: {
        default: null,
      },
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    return SvelteSSRRenderer("pre", CodeBlockView, {
      node,
      attributes: mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      hasContent: true,
      nestedContent: [
        [
          "code",
          {
            class: node.attrs.language
              ? this.options.languageClassPrefix + node.attrs.language
              : null,
          },
          0,
        ],
      ],
    });
  },

  addNodeView() {
    // make sure the inner most content div is <code>
    // schema should be <pre> -> <code>
    return SvelteNodeViewRenderer(CodeBlockView, { contentDOMElementTag: "code" });
  },
});
